import { getAuthToken } from './auth';

const API_BASE = process.env.REACT_APP_API_BASE_URL || '/api';

function authHeaders() {
  const token = getAuthToken();
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
}

async function handleResponse(res) {
  let data = null;
  try { data = await res.json(); } catch (_) {}
  if (!res.ok) {
    const message = (data && (data.message || data.error)) || `Request failed (${res.status})`;
    const err = new Error(message);
    err.status = res.status;
    err.data = data;
    throw err;
  }
  return data;
}

export async function getUnreadCount() {
  const res = await fetch(`${API_BASE}/notifications/unread-count`, { headers: authHeaders() });
  return handleResponse(res);
}

export async function listNotifications({ unread = false, limit = 20 } = {}) {
  const params = new URLSearchParams();
  if (unread) params.set('unread', 'true');
  if (limit) params.set('limit', String(limit));
  const res = await fetch(`${API_BASE}/notifications${params.toString() ? `?${params.toString()}` : ''}`, {
    headers: authHeaders()
  });
  return handleResponse(res);
}

export async function markRead(id) {
  const res = await fetch(`${API_BASE}/notifications/${encodeURIComponent(id)}/read`, {
    method: 'POST',
    headers: authHeaders()
  });
  return handleResponse(res);
}

export async function markAllRead() {
  const res = await fetch(`${API_BASE}/notifications/read-all`, {
    method: 'POST',
    headers: authHeaders()
  });
  return handleResponse(res);
}
